export default () => [
  {
    type: 'checkbox',
    align: 'center',
    width: 40,
  },
  {
    field: 'vehicleModel',
    align: 'center',
    minWidth: 100,
    title: '车辆类型',
    editRender: {
      name: 'dict-select',
      props: {
        default: true,
        clearable: true,
        filterable: true,
        placeholder: '请选择车辆类型',
        body: { type: 'vehicleModel' },
      },
    },
  },
  {
    field: 'vehicleLength',
    align: 'center',
    minWidth: 100,
    title: '车长',
    editRender: {
      name: 'dict-select',
      props: {
        default: true,
        clearable: true,
        filterable: true,
        placeholder: '请选择车长',
        body: { type: 'vehicleLength' },
      },
    },
  },

  {
    field: 'vehicleLoad',
    align: 'center',
    minWidth: 100,
    title: '载重（吨）',
    editRender: {
      name: 'ElInputNumber',
      attrs: { placeholder: '请输入载重' },
    },
  },

  {
    field: 'vehicleVolume',
    align: 'center',
    minWidth: 100,
    title: '载方（立方米）',
    editRender: {
      name: 'ElInputNumber',
      attrs: { placeholder: '请输入载方' },
    },
  },
  {
    field: 'price',
    align: 'center',
    minWidth: 100,
    title: '总价',
    editRender: {
      name: 'ElInputNumber',
      attrs: {
        precision: 4,
        placeholder: '请输入总价',
      },
    },
  },
]
